import BasePolicy from '@/policies/BasePolicy.js';

export default class DiscussionThreadPolicy extends BasePolicy {
    viewAny(user, course) {
        if (user.isStudentSupportOfCourse(course.id)) {
            return false;
        }

        return (
            user.hasPermissionViaCourseTo(course, 'view a discussion thread') ||
            user.hasGroupPermissionWithinCourse(course, 'view a discussion thread')
        );
    }

    view(user, discussionThread, course) {
        return (
            discussionThread.user_id === user.id ||
            user.hasPermissionViaCourseTo(course, 'view a discussion thread') ||
            user.hasGroupPermissionWithinCourse(course, 'view a discussion thread')
        );
    }

    /**
     *
     * @param {User} user
     * @param {Course} course
     * @returns {*}
     */
    create(user, course) {
        return (
            user.hasPermissionViaCourseTo(course, 'create a discussion thread') ||
            user.hasGroupPermissionWithinCourse(course, 'create a discussion thread')
        );
    }

    /**
     *
     * @param {User} user
     * @param {Course} course
     * @returns {*}
     */
    delete(user, thread, course) {
        return (
            thread.user_id === user.id &&
            (user.hasPermissionViaCourseTo(course, 'delete a discussion thread') ||
                user.hasGroupPermissionWithinCourse(course, 'delete a discussion thread'))
        );
    }
}
